/*
 * @Author: tianpeixin 18617269361@163.com
 * @Date: 2023-12-22 11:26:00
 * @LastEditors: zhangke 2211709169@qq.com
 * @LastEditTime: 2026-08-24 10:10:30
 * @FilePath: \app\src\router\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

//创建路由器实例
// const router = new VueRouter({
//   routes: [
//     {
//       path: "/",
//       component: () => import("@/views/Home"),
//       meta: {
//         hideTabBar: true, //是否展示底部tabbar
//       },
//     },
//     {
//       path: "/user",
//       component: () => import("@/views/User"),
//       meta: {
//         hideTabBar: true,
//       },
//     },
//     {
//       path: "/detail",
//       component: () => import("@/views/Detail"), //号码详情
//     },
//     {
//       path: "/waitPay",
//       component: () => import("@/views/WaitPay"), //待支付页面
//     },
//     {
//       path: "/cancelOrder",
//       component: () => import("@/views/OrderDetail"), //已取消页面
//     },
//     {
//       path: "/success",
//       component: () => import("@/views/PaySuccess"), //支付成功
//     },
//     {
//       path: "/fail",
//       component: () => import("@/views/PayFailed"), //支付失败
//     },
//     {
//       path: "/login",
//       component: () => import("@/views/Login"),
//     },
//   ],
// mode: "history",
// });

// export default router;
export const constantRoutes = [
  {
    path: "/",
    component: () => import("@/views/Home"),
    meta: {
      hideTabBar: true, //是否展示底部tabbar
    },
  },
  {
    path: "/customer",
    component: () => import("@/views/customer"), //客服页面
    meta: {
      hideTabBar: true, //是否展示底部tabbar
    },
  },
  {
    path: "/wxCustomer",
    component: () => import("@/views/wxCustomer"), //微信类型的 客服页面
    meta: {
      hideTabBar: true, //是否展示底部tabbar
    },
  },
  {
    path: "/user",
    component: () => import("@/views/User"),
    meta: {
      hideTabBar: true,
    },
  },
  {
    path: "/detail",
    component: () => import("@/views/Detail"), //号码详情
  },
  {
    path: "/waitPay",
    component: () => import("@/views/WaitPay"), //待支付页面
  },
  {
    path: "/cancelOrder",
    component: () => import("@/views/OrderDetail"), //已取消页面
  },
  {
    path: "/success",
    component: () => import("@/views/PaySuccess"), //支付成功
  },
  {
    path: "/fail",
    component: () => import("@/views/PayFailed"), //支付失败
  },
  {
    path: "/login",
    component: () => import("@/views/Login"), //登录
  },
  {
    path: "/qrderQuery",
    component: () => import("@/views/qrderQuery"), //订单列表
  },
  {
    path: "/wxPaySuccess",
    component: () => import("@/views/wxPaySuccess"), //微信小程序 支付成功页面
  },
  {
    path: "/feedBack",
    component: () => import("@/views/customerModel/feedBack.vue"), //意见页面
  },
  {
    path: "/problemList",
    component: () => import("@/views/customerModel/problemList.vue"), //问题列表页面
  },
  {
    path: "/problemDetail",
    component: () => import("@/views/customerModel/problemDetail.vue"), //问题详情页面
  },
  {
    path: "/queryProblem",
    component: () => import("@/views/customerModel/queryProblem.vue"), //问题查询页面
  },

  // {
  //   path: "/earnestMoney",
  //   component: () => import("@/views/earnestMoney"), //定金支付页面
  // },
  // {
  //   path: "/earnestPaySuccess",
  //   component: () => import("@/views/earnestPaySuccess"), //定金支付成功页面
  // },
  // {
  //   path: "/seckillActivity",
  //   component: () => import("@/views/seckillActivity"), //秒杀页面
  // },
];
export default new VueRouter({
  base: "./",
  mode: "history", // 去掉url中的# 线上
  // mode: "hash", //本地开发,发版需要改为history
  routes: constantRoutes,
});
